var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 5.55473C3 4.77658 3.30912 4.03031 3.85935 3.48008C4.40958 2.92984 5.15585 2.62073 5.934 2.62073H14.736C15.5141 2.62073 16.2604 2.92984 16.8107 3.48008C17.3609 4.03031 17.67 4.77658 17.67 5.55473V14.3567C17.67 15.1349 17.3609 15.8811 16.8107 16.4314C16.2604 16.9816 15.5141 17.2907 14.736 17.2907H5.934C5.15585 17.2907 4.40958 16.9816 3.85935 16.4314C3.30912 15.8811 3 15.1349 3 14.3567V5.55473Z",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.76783 9.22219C8.78058 9.22219 9.60158 8.40119 9.60158 7.38844C9.60158 6.37569 8.78058 5.55469 7.76783 5.55469C6.75508 5.55469 5.93408 6.37569 5.93408 7.38844C5.93408 8.40119 6.75508 9.22219 7.76783 9.22219Z",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1879 10.4112L5.93408 17.2907H14.8336C15.5859 17.2907 16.3074 16.9919 16.8393 16.4599C17.3712 15.928 17.6701 15.2066 17.6701 14.4543V14.3567C17.6701 14.0149 17.5417 13.8836 17.3107 13.6306L14.3547 10.4068C14.2169 10.2565 14.0493 10.1366 13.8626 10.0547C13.6759 9.97283 13.4742 9.93074 13.2703 9.93116C13.0664 9.93157 12.8649 9.97447 12.6785 10.0571C12.4922 10.1398 12.3251 10.2604 12.1879 10.4112V10.4112Z",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcImage);
export default __webpack_public_path__ + "static/media/ic-image.57469ad2abb70eeca8f8e7f9abd44ca1.svg";
export { ForwardRef as ReactComponent };